import React from "react";
import { string, bool, func } from "prop-types";
import PlaceholderThumb from "../thumb/PlaceholderThumb";
import "./ThumbnailCheckbox.css";

class ThumbnailCheckbox extends React.Component {
  static PropTypes = {
    text: string,
    checked: bool,
    onCheckboxClick: func,
    thumbnail: string
  };

  constructor(props) {
    super(props);
    this.state = {
      active: this.props.checked || false
    };

    this.onCheckBoxClick = this.onCheckBoxClick.bind(this);
  }

  onCheckBoxClick() {
    const { value, name } = this.props;
    this.setState({ active: !this.state.active });

    this.props.onCheckboxClick(value, name);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checked) {
      this.setState({ active: true });
    }
  }

  render() {
    let [firstName, lastName] = this.props.text.split(" ");

    return (
      <div
        className={`thumbnail-checkbox ${this.state.active ? "active" : ""}`}
        onClick={this.onCheckBoxClick}
      >
        <div className="left">
          <div className="thumbnail">
            {this.props.thumbnail ? (
              <img src={this.props.thumbnail} alt="" />
            ) : (
              <PlaceholderThumb
                firstName={firstName}
                lastName={lastName}
                size={18}
              />
            )}
          </div>
          <span>{this.props.text}</span>
        </div>
        <div className={"checkbox-status"} />
      </div>
    );
  }
}

export default ThumbnailCheckbox;



// WEBPACK FOOTER //
// ./src/common/checkbox/ThumbnailCheckbox.js